import { useFirebaseObject } from "./useFirebaseObject";

export const useProject = (projectId: string) => {
  const [project, updateProject, isLoading] = useFirebaseObject(
    ["projects", projectId].join("/")
  );

  return { project, updateProject, isLoading };
};
